export default __webpack_public_path__ + "static/media/toast-failled.60616603.svg";